import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { StaleVersionNotice } from './components/StaleVersionNotice.js'
import { LanguageProvider } from './i18n.js'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root fehlt im HTML-Dokument.')

createRoot(container).render(
  <StrictMode>
    <LanguageProvider>
      {/* Neben der App und nicht darin: Der Hinweis gilt auf jeder Seite, und
          die App entscheidet je nach Route über völlig verschiedene Bäume. */}
      <StaleVersionNotice />
      <App />
    </LanguageProvider>
  </StrictMode>,
)
